import { match } from 'ts-pattern';
import { UserDb } from './userDb';

export function getTaskOccurrenceTitle(occurrence: UserDb.TaskOccurrence): string {
	return match(occurrence)
		.returnType<string>()
		.with('everyday', () => 'Everyday')
		.with('everyOtherDay', () => 'Every other day')
		.with('monday', () => 'Monday')
		.with('tuesday', () => 'Tuesday')
		.with('wednesday', () => 'Wednesday')
		.with('thursday', () => 'Thursday')
		.with('friday', () => 'Friday')
		.with('saturday', () => 'Saturday')
		.with('sunday', () => 'Sunday')
		.with('onceAWeek', () => 'Once a week')
		.with('onceAmonth', () => 'Once a month')
		.exhaustive();
}
